import '../assets/css/admincustom.css';

function AdminDashboard() {
  return (
    <div>
      <h1 className="bg-warning p-3 ">Welcome to Admin</h1>

        <div className='container'>
            <section class="row px-0 pt-4 px-lg-5">
                <div class="col-md-6 col-lg-4 col-6"> 
                    <article class="p-4 rounded shadow-sm border mb-4 smallCards">
                    <a href="/admin/service" class="d-flex text-decoration-none text-dark align-items-start flex-column">
                        <h5 class="ml-2 smallCardTitles text-white">Services</h5>
                        <a href="/admin/service" className="text-white fw-semibold viewLink">View All</a>
                    </a>
                    </article>
                </div>
                <div class="col-md-6 col-lg-4 col-6"> 
                    <article class="p-4 rounded shadow-sm border mb-4 smallCards">
                    <a href="/admin/work" class="d-flex text-decoration-none text-dark align-items-start flex-column">
                        <h5 class="ml-2 smallCardTitles text-white">Works</h5>
                        <a href="/admin/work" className="text-end text-white fw-semibold viewLink">View All</a>
                    </a>
                    </article>
                </div>
                <div class="col-md-6 col-lg-4 col-6"> 
                    <article class="p-4 rounded shadow-sm border mb-4 smallCards">
                    <a href="/admin/product" class="d-flex text-decoration-none text-dark align-items-start flex-column">
                        <h5 class="ml-2 smallCardTitles text-white">Product</h5>
                        <a href="/admin/product" className="text-end text-white fw-semibold viewLink">View All</a>
                    </a>
                    </article>
                </div>
                <div class="col-md-6 col-lg-4 col-6"> 
                    <article class="p-4 rounded shadow-sm border mb-4 smallCards">
                    <a href="/admin/clientReview" class="d-flex text-decoration-none text-dark align-items-start flex-column">
                        <h5 class="ml-2 smallCardTitles text-white">client Reviews</h5>
                        <a href="/admin/clientReview" className="text-end text-white fw-semibold viewLink">View All</a>
                    </a>
                    </article>
                </div>
                <div class="col-md-6 col-lg-4 col-6"> 
                    <article class="p-4 rounded shadow-sm border mb-4 smallCards">
                    <a href="/admin/userContacts" class="d-flex text-decoration-none text-dark align-items-start flex-column">
                        <h5 class="ml-2 smallCardTitles text-white">User Contacts</h5>
                        <a href="/admin/userContacts" className="text-end text-white fw-semibold viewLink">View All</a>
                    </a>
                    </article>
                </div>
                <div class="col-md-6 col-lg-4 col-6"> 
                    <article class="p-4 rounded shadow-sm border mb-4 smallCards">
                    <a href="/admin/team" class="d-flex text-decoration-none text-dark align-items-start flex-column">
                        <h5 class="ml-2 smallCardTitles text-white">Team Members</h5>
                        <a href="/admin/team" className="text-end text-white fw-semibold viewLink">View All</a>
                    </a>
                    </article>
                </div>
            </section>
        </div>
    </div>
  );
}

export default AdminDashboard;